import React from 'react';
import { LabeledRadio, Label, colors, LabeledRadioProps } from '@commonsku/styles';

const baseOptionsStyle: React.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
};

const radioLabelStyle: React.CSSProperties = {
  color: colors.neutrals[100],
  marginRight: 0,
  marginBottom: 0,
};

interface LabelledRadioProps extends Omit<LabeledRadioProps, 'onChange' | 'label'> {
  optionsStyle?: React.CSSProperties;
  options: Array<{
    key: string;
    value?: string;
    children?: React.ReactNode;
  }>;
  value: string;
  blockStyle?: string;
  onChange: (key: string) => void;
  label?: string | React.ReactNode;
};

const LabelledRadio = ({ className, style, optionsStyle, label, options, value, onChange, disabled, blockStyle = 'inline-block' }: LabelledRadioProps) => {
  return  (
    <div className={className} style={style}>
      {label && <Label>{label}</Label>}
      <div style={{ ...baseOptionsStyle, ...optionsStyle }}>
        {options.map(o => (
          <LabeledRadio
            key={o.key}
            label={o.children ?? o.value}
            checked={value === o.key}
            onChange={() => onChange(o.key)}
            disabled={disabled}
            style={{ display: blockStyle }}
            labelStyle={radioLabelStyle}
          />
        ))}
      </div>
    </div>
  );
};

export default LabelledRadio;
